import { ChangeEvent, FC, useState } from 'react';

import { checkBannerText } from 'utils/constants/banner';

import { TokenBaseStaticSpace } from '@hh.ru/magritte-design-tokens/types';
import { TextArea } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { BannerTextGeneration } from 'components/common/BannerTextGeneration/BannerTextGeneration';
import { MagritteFormField } from 'components/common/MagritteFormField/MagritteFormField';

interface MagritteBannerTextProps {
    value: string;
    onChange: (text: string) => void;
    setBannerText: (text: string) => void;
    vacancyId: string | null;
    error?: string;
    label?: string;
    placeholder?: string;
    dataQa?: string;
    vSpacingBottom?: TokenBaseStaticSpace;
}

const TEXT_AREA_MAX_LENGTH = 81;

const TrlKeys = {
    label: 'create.campaign.input.text.label',
    placeholder: 'create.campaign.input.text.placeholder',
};

export const MagritteBannerText: FC<MagritteBannerTextProps> = ({
    value,
    onChange,
    setBannerText,
    vacancyId,
    error,
    label,
    placeholder,
    dataQa,
    vSpacingBottom,
}) => {
    const [warningTrlKey, setWarningTrlKey] = useState('');

    const trl = useTrls();

    const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        const text = event.target.value;
        const { warningTrlKey, text: checkedText } = checkBannerText(text);
        setWarningTrlKey(warningTrlKey);
        onChange(checkedText);
    };

    return (
        <MagritteFormField
            label={label || trl(TrlKeys.label)}
            labelAdditionalContent={
                <BannerTextGeneration text={value} setBannerText={setBannerText} vacancyId={vacancyId} />
            }
            input={
                <TextArea
                    value={value}
                    onChange={handleChange}
                    placeholder={placeholder || trl(TrlKeys.placeholder)}
                    invalid={!!(error || warningTrlKey)}
                    errorMessage={error || trl(warningTrlKey)}
                    layout="fill-horizontal"
                    maxLength={TEXT_AREA_MAX_LENGTH}
                    data-qa={dataQa || 'text-input'}
                />
            }
            vSpacingBottom={vSpacingBottom}
        />
    );
};
